/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : legalRequirements.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 12-08-2024
 * @description : Legal requirements API details to perform a action
 */

import actionType from "../actionTypes";

const legalRequirements = {
  // Legal standard
  get_legal_standard_details: {
    api_name: "/LCM/legal/standard/view",
    https_method: "GET",
    action_type: actionType.GET_LEGAL_STANDARD_DETAILS,
    description: "",
  },
  get_legal_standard_details_new: {
    api_name: "/LCM/legal/standard/view",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  get_legal_standard_main_details: {
    api_name: "/LCM/legal/standard/view",
    https_method: "GET",
    action_type: actionType.GET_LEGAL_STANDARD_MAIN_DETAILS,
    description: "",
  },
  add_legal_standard: {
    api_name: "/LCM/legal/standard/add",
    https_method: "POST",
    action_type: actionType.ADD_LEGAL_STANDARD,
    description: "",
  },
  update_legal_standard: {
    api_name: "/LCM/legal/standard/update",
    https_method: "PUT",
    action_type: actionType.UPDATE_LEGAL_STANDARD,
    description: "",
  },
  // Legal requirements
  get_legal_requirements_details: {
    api_name: "/LCM/legal/requirement/view",
    https_method: "GET",
    action_type: actionType.GET_LEGAL_REQUIREMENTS_DETAILS,
    description: "",
  },
  get_legal_requirements_details_new: {
    api_name: "/LCM/legal/requirement/view",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  get_legal_requirements_main_details: {
    api_name: "/LCM/legal/requirement/view",
    https_method: "GET",
    action_type: actionType.GET_LEGAL_REQUIREMENTS_MAIN_DETAILS,
    description: "",
  },
  get_legal_requirements_main_details_all: {
    api_name: "/LCM/legal/requirement/view",
    https_method: "GET",
    action_type: actionType.GET_LEGAL_REQUIREMENTS_MAIN_DETAILS_ALL,
    description: "",
  },
  add_legal_requirements: {
    api_name: "/LCM/legal/requirement/add",
    https_method: "POST",
    action_type: actionType.ADD_LEGAL_REQUIREMENTS,
    description: "",
  },
  update_legal_requirements: {
    api_name: "/LCM/legal/requirement/update",
    https_method: "PUT",
    action_type: actionType.UPDATE_LEGAL_REQUIREMENTS,
    description: "",
  },
  import_legal_standard_requirements: {
    api_name: "/LCM/legal/standard/requirements/import",
    https_method: "PUT",
    action_type: "",
    description: "",
  },
  get_legal_standard_table_details: {
    api_name: "/LCM/legal/standard/table/view",
    https_method: "GET",
    action_type: actionType.GET_LEGAL_STANDARD_TABLE_DETAILS,
    description: "",
  },
  add_legal_standard_table: {
    api_name: "/LCM/legal/standard/table/add",
    https_method: "POST",
    action_type: actionType.ADD_LEGAL_STANDARD_TABLE,
    description: "",
  },
  add_legal_standard_table_row: {
    api_name: "/LCM/legal/standard/table/row/add",
    https_method: "POST",
    action_type: actionType.ADD_LEGAL_STANDARD_TABLE_ROW,
    description: "",
  },
  add_legal_standard_table_column: {
    api_name: "/LCM/legal/standard/table/column/add",
    https_method: "POST",
    action_type: actionType.ADD_LEGAL_STANDARD_TABLE_COLUMN,
    description: "",
  },
  add_legal_standard_table_cells: {
    api_name: "/LCM/legal/standard/table/cells/add",
    https_method: "POST",
    action_type: actionType.ADD_LEGAL_STANDARD_TABLE_CELLS,
    description: "",
  },

  get_legal_standards_chapter_for_intersections: {
    api_name: "/ACM/lr-intersections/getLegalStandardAndChapters",
    https_method: "GET",
    action_type: actionType.GET_LEGAL_STANDARD_FOR_INTERSECTIONS,
    description: "",
  },
  get_legal_requirement_for_intersections: {
    api_name: "/ACM/lr-intersections/getLegalRequirements",
    https_method: "GET",
    action_type: actionType.GET_LEGAL_REQUIREMENT_FOR_INTERSECTIONS,
    description: "",
  },
};

export default legalRequirements;
